import { render, staticRenderFns } from "./aiCourseAddPage.vue?vue&type=template&id=0499b9f3&scoped=true&"
import script from "./aiCourseAddPage.vue?vue&type=script&lang=js&"
export * from "./aiCourseAddPage.vue?vue&type=script&lang=js&"
import style0 from "./aiCourseAddPage.vue?vue&type=style&index=0&id=0499b9f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0499b9f3",
  null
  
)

export default component.exports